import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ActiveConsultation {
  consultationId: string;
  patientName: string;
  ownerName: string;
}

interface ConsultationStore {
  activeConsultation: ActiveConsultation | null;
  isCompteRenduModified: boolean;
  isOrdonnanceModified: boolean;
  hasExtracted: boolean;
  dashboardRefreshTrigger: number; // Timestamp to trigger dashboard refresh
  setActiveConsultation: (consultation: ActiveConsultation) => void;
  clearActiveConsultation: () => void;
  markCompteRenduModified: () => void;
  markOrdonnanceModified: () => void;
  resetModifiedFlags: () => void;
  markExtracted: () => void;
  triggerDashboardRefresh: () => void;
}

export const useConsultationStore = create<ConsultationStore>()(
  persist(
    (set) => ({
      activeConsultation: null,
      isCompteRenduModified: false,
      isOrdonnanceModified: false,
      hasExtracted: false,
      dashboardRefreshTrigger: 0,
      setActiveConsultation: (consultation) => set({
        activeConsultation: consultation,
        isCompteRenduModified: false,
        isOrdonnanceModified: false,
        hasExtracted: false,
      }),
      clearActiveConsultation: () => set({
        activeConsultation: null,
        isCompteRenduModified: false,
        isOrdonnanceModified: false,
        hasExtracted: false,
      }),
      markCompteRenduModified: () => set({ isCompteRenduModified: true, hasExtracted: false }),
      markOrdonnanceModified: () => set({ isOrdonnanceModified: true, hasExtracted: false }),
      resetModifiedFlags: () => set({
        isCompteRenduModified: false,
        isOrdonnanceModified: false,
        hasExtracted: true,
      }),
      markExtracted: () => set({ hasExtracted: true }),
      triggerDashboardRefresh: () => set({ dashboardRefreshTrigger: Date.now() }),
    }),
    {
      name: 'consultation-storage',
    }
  )
);
